import { SpriteMaterial, Sprite} from "three"

export let dataNote = []

export const createNote = (scene, note) =>{
    const noteMaterial = new SpriteMaterial({map: note, transparent: true})

    for(let i=0; i < 2; i++){
    const noteMesh = new Sprite(noteMaterial)
    noteMesh.scale.set(0.085, 0.085, 0.085)

    noteMesh.position.x = 1.02 + (Math.random() * (1.02 - 1.15))
    noteMesh.position.y = (Math.random() * (0.1)) + 1.027
    noteMesh.position.z = -1.05

    dataNote.push({
        noteMesh, 
        startPosition: noteMesh.position.clone(),
    })
        scene.add(noteMesh)
    }
}
